import { render, staticRenderFns } from "./CelebritiesDetail.vue?vue&type=template&id=2508f1ca&"
import script from "./CelebritiesDetail.vue?vue&type=script&lang=js&"
export * from "./CelebritiesDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports